import hash from 'object-hash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { UPDATE, UPDATE_BASIC_TABLE_SCHEMA_DATA } from '@/main/store/listEditTypes';
import { Status } from '@/main/store/@types/page';
import { updateEditAction, writeAction } from '@/main/store/actionsFunctions';
import { router } from '@/main/router';
import { convertToObjects } from '@/main/utils/table';

import { DEPENDENT_TABLES, NAME as name, CRUMB_LABEL_KEY, POLOZKY, RPZV_LOG, ZAKAZKA_LIST_FILES, PENDING_JOB_LIST } from '../constants';
import { apiProvider } from '../api';
import { dropdownList, edit, localState } from './state';
import { types } from './types';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	depTableNames: DEPENDENT_TABLES,
	depTableSettings: {
		[POLOZKY]: {
			isEditable: true,
			columns: {
				ZAZNAM_ID: { isEditable: false, required: true },
				REPAIR_INSTRUCTION: { isEditable: true, required: true, type: 'textarea', minWidth: '450px', maxlength: 55 },
				SALARY_AMOUNT: { isEditable: true, align: 'right' },
				EST_COST_PART: { isEditable: true, align: 'right', minWidth: '110px' },
				MAIN_PART_NAME: { isEditable: true },
				SOURCE_TYPE: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
				REMARKS: { isEditable: true, minWidth: '250px' },
				EXECUTED: { isEditable: true, minWidth: '110px' },
				REMARK_TYPE: { isEditable: true, required: true, type: 'dropdown', minWidth: '250px' },
			},
			filter(state) {
				return {
					ZakazkalistId: state.edit.ZakazkalistId,
				};
			},
		},
		[RPZV_LOG]: {
			loadByEntityId: true,
			filter(state) {
				return { ZakazkalistId: state.edit.ZakazkalistId, wantRows: true };
			},
		},
		[PENDING_JOB_LIST]: {
			filter(state) {
				return {
					VozidloId: state.edit.VozidloId,
					ZakazkaId: state.edit.ZakazkaId,
				};
			},


		},
		[ZAKAZKA_LIST_FILES]: {
			filter(state) {
				return {
					ZakazkaId: state.edit.ZakazkaId, wantRows: true,
				};
			},
		},

	},
	edit,
	localState,
	extraActions: {
		async [UPDATE](
			{ commit, dispatch, state },
			data: { id: string | number, goBack: boolean },
		) {
			const polozky = convertToObjects(state.dependentTables.Polozky).map((polozka, idx) => {
				if (polozka.ZaznamId < 0) {
					polozka.ZaznamId = null;
				}
				return ({ ...polozka, ZakazkalistId: data.id, SortZlPol: idx });
			});
			const updatedEntity = {
				...state.edit,
				Polozky: polozky,
			};

			await writeAction(
				state,
				commit,
				dispatch,
				apiProvider.updateEntity(data.id, updatedEntity),
				false,
			);
			if (state.status === Status.ok) {
				commit(types.mutations.COMPUTE_ROWS_HASH);
			}
			if (data.goBack) {
				router.back();
			}
			return state.status === Status.ok ? updatedEntity : null;
		},
		[types.actions.ROZSIRENI_ZAK_LIST]: async ({ commit, dispatch, state }, M2FixacePrp: boolean) => {
			const response = (await apiProvider.rozsireniZakList(state.edit.ZakazkalistId)).data;
			state.edit.TiskDat = response.TiskDat;
			if (M2FixacePrp) {
				state.edit.MenaId2 = response.MenaId2;
			}
		},
		[types.actions.TISK_ZAK_LIST]: async ({ commit, state, dispatch }, data) => updateEditAction(
			state,
			commit,
			dispatch,
			apiProvider.tiskZakList(data),
		),
		[types.actions.GET_RPZV_LOG]: async ({ commit, state, dispatch }) => {
			const resp = (await apiProvider.rpzvLogSchemaAndRows(state.edit.ZakazkalistId)).data;
			commit(UPDATE_BASIC_TABLE_SCHEMA_DATA, { tableName: RPZV_LOG, data: resp });
		},
	},
	extraMutations: {
		[types.mutations.VOZIDLO_RIDIC_MAPPER](state, { data }) {
			state.edit.VrPrijmeni = data.prijmeni;
			state.edit.VrTelNr = data.telefon;
			state.edit.VrJmeno = data.jmeno;
			state.edit.VrEMailAdresa = data.email;
		},

		[types.mutations.COMPUTE_ROWS_HASH](state) {
			state.dependentTables.Polozky.hash = hash(state.dependentTables.Polozky.rows);
		},
	},
	extraGetters: {},
	props: {
		mode: null,
	},
});
